import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export interface ZeroUploadsToastProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  body?: string;
}

const ZeroUploadsToast: React.FC<ZeroUploadsToastProps> = ({
  open,
  onClose,
  title = 'You’re all set, welcome aboard',
  body = 'Drop your first track to get started.',
}) => {
  if (!open) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-[26px] right-[26px] z-[1400] flex max-w-[360px] items-center gap-[13px] rounded-[12px] border border-border bg-surface p-[14px_18px_14px_15px] font-sans shadow-[0_20px_50px_-20px_rgba(0,0,0,0.7)]"
      style={{ borderLeft: '3px solid var(--cyan)' }}
    >
      <div className="grid h-[34px] w-[34px] flex-none place-items-center rounded-[9px] bg-[rgba(39,182,203,0.14)] text-cyan">
        <CheckIcon style={{ fontSize: 18 }} />
      </div>
      <div className="flex-1">
        <b className="block text-[14px] font-semibold text-white">{title}</b>
        <span className="text-[12.5px] text-muted">{body}</span>
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss"
          className="ml-[6px] inline-flex cursor-pointer border-0 bg-transparent p-0 text-faint"
        >
          <CloseIcon style={{ fontSize: 15 }} />
        </button>
      )}
    </div>
  );
};

export default ZeroUploadsToast;
